<template>
	<div class="webContent flex" scroll @scroll="listenScroll">
		<div class="home">
			<div class="banner">
				<div class="uname">Hi, {{user.name}}（{{user.mapperNumber}}）</div>
				<!-- <div class="sign" :class="{ done: isSign }" @click="sign">{{isSign?'今日已签到':'签到'}}</div> -->
				<div class="point">积分：{{point}}</div>
				<div class="search df">
					<input puc type="text" placeholder="搜索" v-model="searchVal" @keyup.enter="search" class="flex" />
					<div class="btn" @click="search"></div>
				</div>
		        <div style='display:none' class="balloon anim_fade_image">+{{integration}}</div>
			</div>
			
			<!-- v2 迭代版本 遗弃版本 暂存-->
			<!-- <div class="list">
				<div class="content model">
					<div class="item" v-for="(v,i) in model" :key="i" 
						:style="'background-image: url('+(v.imageUrl||'')+');'" 
						@click="toList('model', v)">
							<i>{{replaceAll(v.name)}}</i>
					</div>
				</div>
			</div> -->

			<div class="car-compare" @click="toCarCompare">车型对比</div>
			
			<!-- 车型分类改为版块列表 取消话题分类 -->
			<div class="list">
				<div class="li" :class="{ open: isOpen.model }" @click="openLi('model',$event.currentTarget)">{{modelName}}</div>
				<div class="content model" :class="{ show: isOpen.model }" v-show="isOpen.model">
					<div class="item" v-for="(v,i) in model" :key="i" :style="'background-image: url('+(v.imageUrl||'')+');'" @click="toList('model',v)"><i>{{replaceAll(v.name)}}</i></div>
				</div>
				<!-- <div class="li" :class="{ open: isOpen.topic }" @click="openLi('topic',$event.currentTarget)">{{topicName}}</div>
				<div class="content topic" :class="{ show: isOpen.topic }" v-show="isOpen.topic">
					<div class="item" v-for="(v,i) in topic" :key="i" :style="'background-image: url('+(v.imageUrl||'')+');'" @click="toList('topic',v)"><i>{{replace(v.name)}}</i></div>
				</div> -->
			</div>

			<div class="answer">
				<div class="answer-cap">最新解答</div>
				<div class="answer-list">
					<div class="answer-li" v-for="(v,i) in answer" :key="i" @click="toDetail(v)">
						<div class="answer-title"><i v-if="v.announcement==1" class="rule"></i><i v-if="v.refining==1" class="prize"></i><i v-if="v.top==1" class="top"></i>{{v.title}}</div>
						<div class="answer-tool df">
							<div class="flex">{{v.answerTotal>0?v.answerTotal+'人回答':'暂无回答'}} · {{v.attentionTotal>0?v.attentionTotal+'人关注':'暂无关注'}}</div>
							<div><b>{{v.creatorName||''}}（{{v.creatorMapperNumber}}）</b>{{dateTime(v.createTime)}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="signSuccess" :class="{ show: signSuccess==1||signSuccess==2, hide: signSuccess==2 }">签到成功，积分+10</div> -->
	</div>
</template>

<script>
	import h5PublicApi from '../../../script/public.js'

	export default {
		name: 'home_index_page',
		data () {
			return {
				user: '',
				// isSign: false,
				// signSuccess: 0,
				point: 0,
				isAddPoint:false,
				searchVal: '',
				isOpen: {
					model: false, // 车型分类
					topic: false, // 话题分类
					material: false, // 下载/播放专区
				},
				modelName: '版块列表',
				model: [], // 车型分类
				topicName: '话题分类',
				topic: [], // 话题分类
				// materialName: '下载/播放专区',
				// material: [], // 下载/播放专区
				pagenum: 1,
				pagesize: 10,
				state: false,
				answer: [],
				integration:0
			}
		},
		mounted(){
			var type = h5PublicApi.tabNavTed('get','homeType','');
			if(type) this.isOpen[type] = true;
			h5PublicApi.tabNavTed('set','homeType','');


			// 获取登录用户详细信息
			this.h5Ajax('get','$/user/info',{},true).then(r=>{
				h5CloseLoad();
				this.user = r;
				this.point = r.integration;
				this.sign();
			}).catch(err => {
				console.error('err:' + err)
			})

			// 获取首页版块信息
			this.h5Ajax('get','$/category/listFlatCatgories',{ // /category/
				page: 1,
				pid: 0,
				size: 100,
				types: 1,
			}, true).then(r=>{
				this.model = r
			}).catch(err => {
				console.error('err:' + err)
			})

			this.getAnswer();

			h5PublicApi.tabNavTed('set','meIndexModel','');
			h5PublicApi.tabNavTed('set','meIndexNav','');
			h5PublicApi.tabNavTed('set','meIndexNav2','');
			h5PublicApi.tabNavTed('set','messageIndexModel','');
			h5PublicApi.tabNavTed('set','messageIndexNav','');
			h5PublicApi.tabNavTed('set','messageIndexNav2','');
			h5PublicApi.tabNavTed('set','adminIndexModel','');
		},
		methods: {
			 sign(){
			 	this.h5Ajax('post','$/user/signIn',{}, true).then(r=>{
					if(r.integration>0){
						this.integration = r.integration;
						this.showPoint();
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			 },
			dateTime(timestamp){
				if(!timestamp){ return ''; }
				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			replaceAll(text){
                  var reg = new RegExp("<br/>","g");
                  var x = text.replace(reg,"");
                  return x
		    },
			openLi(type,obj){
				if(this.isOpen[type]){
					h5PublicApi.tabNavTed('set','homeType','');
					this.isOpen[type] = false;
					return false;
				}

				this.isOpen = {
					model: false,
					topic: false,
					material: false,
				};
				this.isOpen[type] = true;

				setTimeout(function(){
					var targetTop = obj.offsetTop + h5PublicApi.remToPx('0.39rem');

					var scrollObj = document.getElementsByClassName('webContent');
					if(scrollObj.length>0){
						// scrollObj[0].scrollTop = targetTop;
						h5PublicApi.scrollAnimation(scrollObj[0],targetTop)
					}
				},10)
			},
			listenScroll(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData();
				}
			},
			addMoreData() { //加载更多
				if(this.state){
					return false;
				}
				this.pagenum ++;
				this.getAnswer();
			},
			getAnswer(){
				this.state = true;

				this.h5Ajax('get','$/questions/homeList',{
					page: this.pagenum,
					size: this.pagesize,
				}, true).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.answer.push(d)
						}
						this.state = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			search(){
				this.$router.replace({ path: '/home/search', query: { keyword: this.searchVal } });
			},
			toList(type, data){
				// console.log(type, data)
				if(data.name == '积分榜'){
					this.$router.replace({ path: '/model/league' });
				}else{
					h5PublicApi.tabNavTed('set','homeType',type);
					this.$router.replace({ path: '/'+type+'/list', query: { id: data.id, name: data.name } });
				}
				
			},
			toDetail(data){
				this.$router.replace({ path: '/model/detail', query: { id: data.id } });
			},
			toCarCompare(){
				this.$router.replace({ path: '/model/comparison' });
			},
			showPoint(){
				var obj = document.getElementsByClassName('balloon')[0];
				obj.style.display = 'block';
				obj.style.bottom = '0px';
				var y = 110;
				var init =0;
				var clock = setInterval(r=>{
				init++;
				if(init<20){
					obj.style.bottom = init*5 +'px';
						}else{
							if(obj.style.bottom != '110px'){
								obj.style.bottom = '110px';
								obj.style.display = 'none';
							}
							clearInterval(clock);
						}
					},100)
				},
				replace(input){
					return input.replace('<br/>','');
				}
		},
	}
</script>

<style scoped>
	@import './index'
</style>



// WEBPACK FOOTER //
// src/app/pages/home/index/index.vue